import { isObject } from "lodash-es";
import { arrayify } from "../../../../lib/utils/array";
export default function getFormItemLayout(dataStub, children, fitDataResult) {
  const {
    ui
  } = dataStub.schema;
  const label = dataStub.getTitle();
  // 高级流程上下文
  const required = dataStub.path.startsWith('___temp_data_placeholder___.') ? {
    required: !!dataStub.schema.required
  } : {};
  return {
    type: 'w-form-item',
    props: {
      label,
      description: dataStub.schema.description || '',
      ...required
    },
    children: arrayify(children).map(child => {
      var _fitDataResult$inheri;
      // 由于一些历史原因，这里的代码会污染到第一个推导结果
      // 但是已经不敢改了，无极里似乎依赖了一大堆
      if (ui && ((_fitDataResult$inheri = fitDataResult === null || fitDataResult === void 0 ? void 0 : fitDataResult.inheritAttrs) !== null && _fitDataResult$inheri !== void 0 ? _fitDataResult$inheri : true)) {
        const changeChild = [() => {
          if (ui.className) child.class = `${child.class || ''} ${ui.className}`.trim();
        }, () => {
          if (ui.style && isObject(ui.style)) child.style = {
            ...child.style,
            ...ui.style
          };
        }, () => {
          if (ui.settings) child.props = {
            ...ui.settings,
            ...child.props
          };
        }, () => {
          if (ui.props) child.props = {
            ...child.props,
            ...ui.props
          };
        }];
        changeChild.forEach(cb => {
          try {
            cb();
          } catch (e) {
            // 会有child.props是getter的情况 会走到这里
          }
        });
      }
      try {
        child.props = {
          ...child.props,
          placeholder: `请输入${label}`
        };
      } catch (e) {
        // 会有child.props是getter的情况 会走到这里
      }
      return child;
    })
  };
}